import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { Divider, Form, notification } from 'antd';

import { getImgUrl } from '@/core/domain/archive/Archive/Archive.utils';

import { CreateConsumableRequest } from '@/core/domain/operational/Consumables/Consumables.types';
import { useCreateConsumable } from '@/core/domain/operational/Consumables/Consumables.hooks';

import { PageProps } from '@/types/PageProps';

import ConsumableForm, {
  ConsumableFormData,
} from '@/components/Operational/Inventory/Consumables/ConsumableForm';
import { SaveButton } from '@/components/_common/Buttons';
import { TabContentWrapper } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const CreateConsumablePage = ({ route }: PageProps) => {
  const intl = useIntl();
  const history = useHistory();
  const [form] = Form.useForm<ConsumableFormData>();

  const createMutation = useCreateConsumable();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreateConsumableRequest = {
        ...values,
        imageUrl: values.imageUrl ? getImgUrl(values.imageUrl[0]) : undefined,
      };

      const result = await createMutation.mutateAsync(obj);

      notification.success({
        message: intl.formatMessage({
          id: 'consumables.create.notifications.success.title',
        }),
        description: intl.formatMessage({
          id: 'consumables.create.notifications.success.description',
        }),
      });

      history.push(`/app/operational/inventory/consumables/${result.id}`);
    } catch {}
  };

  return (
    <>
      <Helmet title={intl.formatMessage({ id: 'consumables.create' })} />

      <TabContentWrapper
        title={route.name}
        extra={
          <SaveButton
            type="primary"
            onClick={handleSaveClick}
            loading={createMutation.isLoading}
            disabled={!hasPermissions([Authorities.REGISTER_CONSUMABLE_ADD])}
          >
            <FormattedMessage id="commons.entity.save" />
          </SaveButton>
        }
      >
        <ConsumableForm form={form} isLoading={false} />

        <Divider />

        <SpaceForButton>
          <ButtonBack path="/app/operational/inventory/consumables" />
        </SpaceForButton>
      </TabContentWrapper>
    </>
  );
};

export default CreateConsumablePage;
